import React from 'react';

const NotificationActivityLogItem = ({ log, isNew }) => {
  const getActionIcon = (action) => {
    const iconMap = {
      'USER_SIGNED_IN': '🔑',
      'USER_SIGNED_IN_GOOGLE': '🔑',
      'USER_SIGNED_IN_MICROSOFT': '🔑',
      'USER_SIGNED_OUT': '👋',
      'PROJECT_CREATED': '📁',
      'PROJECT_RENAMED': '✏️',
      'PROJECT_UPDATED': '📝',
      'PROJECT_DELETED': '🗑️',
      'PAGE_ANNOTATED': '✍️',
      'PAGE_SAVED': '💾',
      'PLANNING_SAVED': '📅',
      'ASSEMBLY_CREATED': '🔧',
      'ASSEMBLY_DELETED': '❌',
      'RESOURCE_PROJECT_SAVED': '📦',
      'RESOURCE_SAVED': '📦',
      'RESOURCE_UPDATED': '📦',
    };
    return iconMap[action] || '📋';
  };

  const formatAction = (action) => {
    return action
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  const renderDetails = () => {
    const { details } = log;
    if (!details) return null;

    const parts = [];
    if (details.projectName) parts.push(`${details.projectName}`);
    if (details.version) parts.push(`v${details.version}`);
    if (details.page !== undefined) parts.push(`page ${details.page}`);

    return parts.length > 0 ? ` — ${parts.join(' • ')}` : null;
  };

  return (
    <div className={`notification-activity-item ${isNew ? 'notification-activity-item--new' : ''}`}>
      <span className="notification-activity-icon">{getActionIcon(log.action)}</span>
      <div className="notification-activity-content">
        <div className="notification-activity-summary">
          <strong>{formatAction(log.action)}</strong>
          {renderDetails()}
          {isNew && <span className="notification-new-badge">NEW</span>}
        </div>
        <div className="notification-activity-meta">
          <span className="notification-activity-actor">{log.actorEmail || log.actorUid || 'System'}</span>
          {log.organization && (
            <>
              <span className="notification-activity-separator"> • </span>
              <span className="notification-org-badge">{log.organization}</span>
            </>
          )}
          <span className="notification-activity-separator"> • </span>
          <span className="notification-activity-time">{formatTimestamp(log.timestamp)}</span>
        </div>
      </div>
    </div>
  );
};

export default NotificationActivityLogItem;
